import { render, staticRenderFns } from "./PasswordEdit.vue?vue&type=template&id=af43ac1c&"
import script from "./PasswordEdit.vue?vue&type=script&lang=js&"
export * from "./PasswordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PasswordEdit.vue"
export default component.exports